<template>
  <section class="permissions column__layout">
    <!-- <pre> {{ selectedProfile.abilities }}</pre> -->
    <section class="permissions__header">
      <v-btn
        class="border__radius-10"
        :color="typeOfAction.color"
        height="45"
        dark
        outlined
        depressed
        @click="changeSelectedData"
      >
        <v-icon class="mr-3" small>{{ typeOfAction.icon }} </v-icon>
        Habilidades: {{ typeOfAction.action }}
      </v-btn>
      <span class="ml-4 subtitle-1 font-weight-bold">  
         {{ selectedProfile ? selectedProfile.name : "" }}
      </span>
    </section>

    <!-- lista de habilidades -->
    <section class="permissions__group">
      <v-checkbox
        v-for="ability in systemAbilities"
        :key="ability.id"
        v-model="selectedPermissions"
        :label="ability.name"
        :value="ability.id"
      />
      <!-- <pre>{{ selectedProfile }}</pre> -->
      <!-- <pre>{{ ability }}</pre> -->
      <!-- <pre>System Abilities: {{ systemAbilities }}</pre> -->
    </section>

    <!-- Botões -->
    <section class="buttons__actions__layout">
      <v-btn
        class="border__radius-10"
        height="45"
        depressed
        :loading="isLoading"
        :disabled="isLoading"
        @click="returnToGrid"
      >
        VOLTAR
      </v-btn>

      <v-btn
        class="border__radius-10"
        height="45"
        color="primary"
        depressed
        :loading="isLoading"
        :disabled="isLoading"
        @click="saveAbilities"
      >
        SALVAR
      </v-btn>
    </section>

    <!-- testar com v-show -->
    <SuccessComponent
      v-if="showSuccess"
      :message="successMessage"
      @close="showSuccess = false"
    />
  </section>
</template>

<script>
import axios from "@/axios";
import SuccessComponent from "../alerts/Success-component.vue";

export default {
  name: "ChangePermissionsComponent",

  props: {
    abilities: {
      type: Array,
      default: () => [],
    },
    systemAbilities: {
      type: Array,
      required: true,
    },

    selectedProfile: {
      type: Object,
      default: null,
      // required: true,
    },
  },

  components: {
    SuccessComponent,
  },

  data: () => ({
    // selectedProfile: null, // perfil selecionado
    selectedPermissions: [], // ids das habilidades selecionadas
    // systemAbilities: [],
    // allAbilities: [],
    isLoading: false,
    showSuccess: false,
    successMessage: "",
  }),

  computed: {
    typeOfAction() {
      const isAllSelected =
        this.systemAbilities.length > 0 &&
        this.systemAbilities.length === this.selectedPermissions.length;

      return !isAllSelected
        ? {
            status: isAllSelected,
            color: "#1876D2",
            icon: "mdi-checkbox-multiple-marked-outline",
            action: "Selecionar Todos",
          }
        : {
            status: isAllSelected,
            color: "#424242",
            icon: "mdi-checkbox-multiple-blank-outline",
            action: "Desmarcar Todos",
          };
    },

    headerData() {
      return {
        title: "Habilidades: ",
        subtitle: this.selectedProfile.name,
      };
    },
  },

  watch: {
    abilities: {
      handler(newVal) {
        this.selectedPermissions = [...newVal]; // clona o array para o v-model
      },
      immediate: true, // garante que ao montar o componente, o valor já é atribuído
    },
  },

  methods: {
    returnToGrid() {
      this.$emit("close");
    },
    changeSelectedData() {
      this.selectedPermissions = !this.typeOfAction.status
        ? this.systemAbilities.map((a) => a.id)
        : [];
    },

    // Botão Salvar que dispara um POST para vincular as permissões ao perfil selecionado.
    async saveAbilities() {
      this.isLoading = true;
      try {
        const response = await axios.post(
          `/profile/${this.selectedProfile.id}/abilities`,
          { abilities: this.selectedPermissions }
        );

        await this.$swal({
          icon: "success",
          title: response.data.message || "Habilidade vinculada com sucesso!",
          timer: 1500,
          showConfirmButton: false,
        });

        // this.successMessage = response.data.message || "Habilidade vinculada com sucesso";
        //   this.$nextTick(() => {
        // this.showSuccess = true;

        setTimeout(() => {
          this.showSuccess = false;
          this.$emit("updateGrid"); // atualiza a grid
          this.$emit("close");
        }, 1500); // volta pra grid depois de 1.5s
      } catch (error) {
        console.error("Erro ao salvar habilidades:", error);
        this.successMessage = "Erro ao salvar habilidades!";
        this.showSuccess = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.permissions {
  .permissions__header {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
  }

  .permissions__group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 10px;
    margin: 5px;
    padding: 25px;
    border-radius: 20px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
      rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }
}
</style>
